import { useMemo } from "react";
import {
  CANVAS_ASSET_ID_PREFIX,
  TABLE_ASSET_ID_PREFIX,
  ZAP_ASSET_ID_PREFIX,
} from "@zapier/utils";
import { useSplitTreatments } from "../split/useSplitTreatments";

/** Asset id prefixes currently wired into the unified-trash restore/delete-forever pipeline. */
export function useTrashEnabledAssetPrefixes(): string[] {
  const { isZapAndCanvasUnifiedTrashEnabled, isTableUnifiedTrashEnabled } =
    useSplitTreatments();

  return useMemo(() => {
    const prefixes: string[] = [];
    if (isZapAndCanvasUnifiedTrashEnabled) {
      prefixes.push(CANVAS_ASSET_ID_PREFIX, ZAP_ASSET_ID_PREFIX);
    }
    // Tables require both the base unified-trash flag and their own flag -
    // they don't ride the single consolidated flag the way Zap/Canvas do.
    if (isZapAndCanvasUnifiedTrashEnabled && isTableUnifiedTrashEnabled) {
      prefixes.push(TABLE_ASSET_ID_PREFIX);
    }
    return prefixes;
  }, [isZapAndCanvasUnifiedTrashEnabled, isTableUnifiedTrashEnabled]);
}
